module.exports = __webpack_public_path__ + "static/img/ban5.4d7b5cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/ban5.jpg
// module id = dP7u
// module chunks = 55